import { useContext, useMemo, useState } from 'react';
import { CurrentUserContext } from "../components/utils/CurrentUserContext";

const useUserRoles = () => {
    const user = useContext(CurrentUserContext);

    return useMemo(() => {
        if (!user) {
            return {
                roles: [],
                isCommissioner: false,
                isCaptain: false,
                loading: true,
                error: null,
            };
        }
        const {
            roles: roleNames = [],
            is_commissioner = false,
            is_captain = false,
        } = user;

        return {
            roles: roleNames,
            isCommissioner: is_commissioner,
            isCaptain: is_captain,
            loading: false,
            error: null,
        };
    }, [user]);

};

export default useUserRoles;
